import React from 'react';

import './footer.styles.css'


const Footer = () => (
    <footer className="footer">
    <div className="footer__logo-box">    
        <img  className="footer__logo"  alt="Full logo" src="img/logo-greben.png"/> 
    </div>
    <div className="row">
        <div className="col-1-of-2">
        <div className="col-1-of-2">
            <p className="footer__copyright"> 
            Planinarski Klub "Greben" Mladenovac                       
            Kralja Petra I 175
            11400 Mladenovac
            E-mail greben.pk@gmail.com         
            </p>
        </div>
        </div>
        <div className="col-1-of-2">
            <p className="footer__copyright">                        
                Copyright &copy;  <a  className="footer__link">PK GREBEN</a>  2020. Build by <a  className="footer__link">C&K </a> 
                 Design by <a  className="footer__link">C&K</a>              
            </p>
        </div>
    </div>
</footer>
);


export default Footer;